export interface IAccount {
  CompanyAssign: any[];
  id: string;
  name?: string;
  address: string;
  tenantId: string;
  crNumber: string;
  phone: string;
  email: string;
  website: string;
  pincode: string;
  city: string;
  country: string;
  ProfileURL: string | null;
  createdAt: string;
  updatedAt: string;
  type?: string;
  assignedId: any;
  assignedType: string;
  createdById?: string;
  modifiedById?: string;
  assignedUser?: any;
  assignedTeam?: any;
  assignUsers?: any;
  users?: any[];
  customFields?: any[];
  customData?: Record<string, any>;
  CompanyFieldValue?: any[];
  assignUserListName?: Array<{ name: string; type: string; id: any } | string>;
}

export interface AccountListTable extends IAccount {
  action: string;
}

export interface IAccountCreate {
  name: string;
  email: string;
  phone: string;
  crNumber: string;
  pincode: string;
  city: string;
  country: string;
  website: string;
  address: string;
  assignUsers: any[] | [];
}

export const defaultAccount: IAccount = {
  CompanyAssign: [],
  id: '',
  name: '',
  address: '',
  tenantId: '',
  crNumber: '',
  phone: '',
  email: '',
  website: '',
  pincode: '',
  city: '',
  country: '',
  ProfileURL: null,
  createdAt: '',
  updatedAt: '',
  assignedId: '',
  assignedType: '',
};
